import { ModelBase } from 'store/model-base';

export class OtResponseActivations {
    public status?: string;
    public activationMethod?: string;
}

export class OtResponseStatus {
    public note?: string;
}

export class LineStatuses {
    public nickname: string;
    public lineId: string;
    public badge?: string;
    public badgeColor?: string;
    public footer?: string;
    public footerDestination?: string;
    public otResponseActivations?: OtResponseActivations;
    public otResponseStatus?: OtResponseStatus;
}

export class LineStatusCollection extends ModelBase {
    public static storeName: string = 'lineStatusCollection';

    public lineStatuses: LineStatuses[];

    public static create<T extends ModelBase>(initData: object): T {
        return super.create<T>(initData);
    }

    public getMatchedLineStatuses(lineIdValue: string, lineIdKey: string): LineStatuses {
        const matchedDevice: LineStatuses = this.lineStatuses.find(
            (lineStatuses: LineStatuses) => (lineStatuses?.lineId === lineIdValue) || (lineStatuses?.lineId === lineIdKey)
        );
        if (matchedDevice) {
            return matchedDevice;
        }

        return undefined;
    }
}
